export default __webpack_public_path__ + "static/media/RobotoSlab-Light.0a0b244f.ttf";